import { render, staticRenderFns } from "./Sprite.vue?vue&type=template&id=5f12875a&"
import script from "./Sprite.vue?vue&type=script&lang=js&"
export * from "./Sprite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports